import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MatchCard } from '../../components/matching/MatchCard';
import { findMatchesForBrand, findMatchesForOrganizer, MatchResult } from '../../services/matchingService';
import { useAuth } from '../../context/AuthContext';
// Mock data imports would go here in a real app
// For now we'll simulate data
export function MatchResultsPage() {
  const {
    currentUser
  } = useAuth();
  const [matches, setMatches] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Simulate fetching matches
    const loadMatches = async () => {
      setLoading(true);
      // In a real app, we'd fetch the current profile and potential matches from DB
      // Here we'll mock the response structure
      setTimeout(() => {
        const mockMatches = Array.from({
          length: 5
        }).map((_, i) => ({
          match: {
            id: `match-${i}`,
            score: 95 - i * 5,
            matchReasons: ['High audience overlap in Gen Z', 'Budget fits perfectly', 'Industry alignment: Tech', 'Activation space available'],
            details: {}
          } as MatchResult,
          profile: {
            name: currentUser?.type === 'brand' ? `Tech Summit 202${i}` : `TechCorp ${i}`,
            description: 'Leading innovation conference bringing together industry leaders.',
            location: 'San Francisco, CA',
            imageUrl: ''
          }
        }));
        setMatches(mockMatches);
        setLoading(false);
      }, 1000);
    };
    loadMatches();
  }, [currentUser]);
  return <DashboardLayout data-id="element-2070">
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-2071">
        <div className="flex justify-between items-center mb-8" data-id="element-2072">
          <div data-id="element-2073">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-2074">Top Matches</h1>
            <p className="text-gray-500 mt-1" data-id="element-2075">
              Based on your profile and preferences
            </p>
          </div>
          <div className="flex gap-2" data-id="element-2076">
            <select className="border-gray-300 rounded-lg text-sm" data-id="element-2077">
              <option data-id="element-2078">Sort by Score</option>
              <option data-id="element-2079">Sort by Date</option>
            </select>
          </div>
        </div>

        {loading ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2080">
            {[1, 2, 3].map(i => <div key={i} className="bg-white rounded-xl h-80 animate-pulse bg-gray-100" data-id="element-2081" />)}
          </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2082">
            {matches.map((item, i) => <MatchCard key={i} match={item.match} name={item.profile.name} description={item.profile.description} location={item.profile.location} imageUrl={item.profile.imageUrl} type={currentUser?.type === 'brand' ? 'brand' : 'organizer'} data-id="element-2083" />)}
          </div>}
      </div>
    </DashboardLayout>;
}